import QUERY from 'lodash'

export default {

  data () {
    return {
      requesterSignatory: {
        stage: 0,
        approver_label: 'Retail Officer - Origin',
        approver_action: 'Purchase Order',
        approver_name: '',
        last_seen: '',
        status: 'Requested',
        status_at: '',
        remarks: ''
      },
      canceledSignatory: {
        stage: 1,
        approver_label: 'Retail Officer - Origin',
        approver_action: 'Cancellation',
        approver_name: '',
        last_seen: '',
        status: 'Canceled',
        status_at: '',
        remarks: ''
      }
    }
  },

  computed: {
    SubmitRequestAsDraftButton () {
      if (this.editing) {
        return 'Update Draft'
      }

      return 'Save Draft'
    }
  },

  methods: {

    vTabStockRequest () {
      if (this.$refs.formStockRequest) {
        return Object.keys(this.$refs.formStockRequest.errors).find(
          key => this.$refs.formStockRequest.errors[key]?.length > 0
        )
      }

      return false
    },

    vTabProducts () {
      if (this.$refs.formProducts) {
        return Object.keys(this.$refs.formProducts.errors).find(
          key => this.$refs.formProducts.errors[key]?.length > 0
        )
      }

      return false
    },

    vTabDeliveryDetails () {
      if (this.$refs.formCustomer) {
        return Object.keys(this.$refs.formCustomer.errors).find(
          key => this.$refs.formCustomer.errors[key]?.length > 0
        )
      }

      return false
    },

    showRequest (stockRequest) {
      this.editing = true

      const { headers, delivery_details, details } = stockRequest

      this.getProducts(this).finally(() => {
        this.stockRequest = Object.assign(this.stockRequest, {
          id: stockRequest.id,
          stage: 0,
          references: {
            document_number: '',
            transfer_number: '',
            sap_doc_entry: '',
            transaction_number: ''
          },
          headers: {
            group: '',
            group_code: '',
            group_name: ''
          },
          delivery_details: {
            customer_direct: Number(headers.customer_direct),
            customer: delivery_details.customer,
            mobile_number: delivery_details.mobile_number,
            address: delivery_details.address
          },
          schedule_details: {
            date: '',
            vehicle: '',
            vehicle_plate: '',
            vehicle_name: '',
            driver: '',
            driver_name: '',
            mobile_number: '',
            helper: ''
          },
          details: details.map(
            detail => Object.assign(detail, {
              product: QUERY.find(this.options.products, {
                product_code: detail.product_code
              })
            })
          ),
          approvals: [],
          remarks: headers.remarks,
          created_at: ''
        })

        this.getOrigins(this).finally(() => {
          this.selected.origin = QUERY.find(this.options.origins, {
            id: headers.origin
          })
        })

        this.getDestinations(this).finally(() => {
          this.selected.destination = QUERY.find(this.options.destinations, {
            id: headers.destination
          })
        })

        this.$refs.srDraft.loaded()
        this.$bvModal.show('modalRequest')
      })
    },

    showRequestPreview (stockRequest) {
      const { delivery_details, schedule_details } = stockRequest

      this.stockRequest = Object.assign(this.stockRequest, {
        id: stockRequest.id,
        stage: stockRequest.stage,
        references: {
          document_number: stockRequest.document_number,
          transfer_number: stockRequest.transfer_number,
          sap_doc_entry: stockRequest.sap_doc_entry,
          transaction_number: stockRequest.transaction_number
        },
        headers: {
          origin: stockRequest.origin_id,
          origin_code: stockRequest.origin_code,
          origin_name: stockRequest.origin_name,
          group: stockRequest.group_id,
          group_code: stockRequest.group_code,
          group_name: stockRequest.group_name
        },
        delivery_details: {
          customer_direct: Number(stockRequest.customer_direct),
          customer: delivery_details.customer,
          mobile_number: delivery_details.mobile_number,
          address: delivery_details.address
        },
        schedule_details: {
          date: schedule_details?.date || '',
          vehicle: schedule_details?.vehicle || '',
          vehicle_plate: schedule_details?.vehicle_plate || '',
          vehicle_name: schedule_details?.vehicle_name || '',
          driver: schedule_details?.driver || '',
          driver_name: schedule_details?.driver_name || '',
          mobile_number: schedule_details?.mobile_number || '',
          helper: schedule_details?.helper || ''
        },
        details: stockRequest.transfer_details,
        approvals: stockRequest.approvals,
        remarks: stockRequest.remarks,
        created_at: stockRequest.created_at
      })

      this.requesterSignatory = Object.assign(this.requesterSignatory, {
        approver_name: stockRequest.destination_name,
        status_at: stockRequest.created_at
      })

      this.canceledSignatory = Object.assign(this.canceledSignatory, {
        approver_name: stockRequest.destination_name,
        remarks: stockRequest.canceled_remarks,
        status: stockRequest.status,
        status_at: stockRequest.canceled_at
      })

      this.$bvModal.show('modalRequestPreview')
    }

  }
}
